import { render, staticRenderFns } from "./QuiEl.vue?vue&type=template&id=13b68c7e&"
import script from "./QuiEl.vue?vue&type=script&lang=js&"
export * from "./QuiEl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports